import { createContext, useContext, useState } from 'react';
import { Notification } from '../model/notification';

/**
 * Notification command
 */

interface NotificationContextType {
    notification: Notification[];
    setNotification: (notification: Notification[]) => void;
    isOpenNotif: boolean;
    setIsOpenNotif: (isOpenNotif: boolean) => void;
    addNotification: (notification: { commandId: any; content: any; type: string; title?: string }) => void;
    removeNotification: (index: number) => void;
    clearNotifications: () => void;
}

const NotificationContext = createContext<NotificationContextType>({
    notification: [],
    setNotification: () => {},
    isOpenNotif: false,
    setIsOpenNotif: () => {},
    addNotification: () => {},
    removeNotification: () => {},
    clearNotifications: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function NotificationProvider({ children }: Props) {
    const [notification, setNotification] = useState<Notification[]>([]);
    const [isOpenNotif, setIsOpenNotif] = useState(false);

    // Function to add a notification to the queue _
    const addNotification = ({ commandId, content, type, title }) => {
        if (!title) title = 'RADIER UN SALARIE';
        const storedNotifications = localStorage.getItem('notificationMessages');
        let notifications = storedNotifications ? JSON.parse(storedNotifications) : [];
        const newNotif: Notification = { id: commandId, content, type, title };
        const isInList = isNotifInList(newNotif, notifications);
        if (!isInList) {
            notifications.push(newNotif);
            localStorage.setItem('notificationMessages', JSON.stringify(notifications));
            setNotification(notifications);
        }
    };

    // Function to remove a notification from the queue
    const removeNotification = (index: number) => {
        let notifications = JSON.parse(localStorage.getItem('notificationMessages') || '[]');
        notifications.splice(index, 1);
        localStorage.setItem('notificationMessages', JSON.stringify(notifications));
        setNotification([...notifications]);
    };

    // Function to clear all notifications from the queue
    const clearNotifications = () => {
        localStorage.removeItem('notificationMessages');
        setNotification([]);
    };

    const isNotifInList = (newNotif: Notification, notifications: Notification[]) => {
        const notif = notifications.find((r) => {
            return r.id === newNotif.id;
        });
        return notif ? true : false;
    };

    return (
        <NotificationContext.Provider
            value={{
                notification,
                setNotification,
                isOpenNotif,
                setIsOpenNotif,
                addNotification,
                removeNotification,
                clearNotifications,
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
}

export const useNotificationContext = (): NotificationContextType => useContext(NotificationContext);
